import styled, { css } from 'styled-components';
import { Card } from '../Card/index.js';
import { Arrow } from '../Icons/components/Arrow.js';

const FilterButtonWrap = styled(Card).withConfig({
    displayName: "styles__FilterButtonWrap",
    componentId: "sc-b6bd12cc-0"
})`
    user-select: none;
    position: relative;
    padding: 12px ${(props)=>props.theme.spacers.L};
    color: ${(props)=>props.theme.colors["Level 4"]};
    ${({ theme  })=>css(theme.typography.Paragraph)};
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
`;
const Icon = styled(Arrow).withConfig({
    displayName: "styles__Icon",
    componentId: "sc-b6bd12cc-1"
})`
    color: ${(props)=>props.theme.colors["Level 3"]};
    transform: rotate(-90deg);
`;
const RippleContainer = styled.div.withConfig({
    displayName: "styles__RippleContainer",
    componentId: "sc-b6bd12cc-2"
})`
    border-radius: 4px;
    width: 100%;
    height: 100%;
    position: absolute !important;
    top: 0;
    left: 0;
`;

export { FilterButtonWrap, Icon, RippleContainer };
